import { Stack } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";

import css from "./processing_overlay.module.scss";

type ProcessingOverlayProps = {
  title: string;
  subtitle: string;
};

export const ProcessingOverlay = ({ title, subtitle }: ProcessingOverlayProps) => (
  <Stack className={css.processingOverlay} alignItems="center">
    <LoadingDots circlesEnabled />
    <Typography variant="h2">{title}</Typography>
    <Typography variant="bodyRegular">{subtitle}</Typography>
  </Stack>
);
